// actions.js

export const clearStore = () => ({
    type: 'CLEAR_STORE',
});
